import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CreateOneShopImportDto, ShopDto } from "../generated/schema";

type AddImportMethodParams = {
  shopImport: CreateOneShopImportDto;
};

export default function useAddImportMethod(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();

  const mutation = $api.useMutation("post", "/shops/{shopId}/imports");

  return useMutation({
    onSuccess: () => {
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async ({ shopImport }: AddImportMethodParams) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id } },
        body: shopImport,
      });
    },
  });
}
